export default __webpack_public_path__ + "static/media/economy-arrow.a21403c7.png";